const menuHighlight = () => {
  const menuHighlight = document.querySelector(".js-menu-highlight");
  if (!menuHighlight) return;

  const options = {
    root: null,
    rootMargin: "-100px 0px -66% 0px",
    threshold: 0
  };

  const sections = [];
  document.querySelectorAll(".js-menu-highlight a").forEach((link) => {
    const href = link.getAttribute("href");
    if (href && href.startsWith("#")) {
      const sectionId = href.substring(1);
      const section = document.getElementById(sectionId);
      if (section) {
        sections.push({ section, link });
      }
    }
  });

  if (sections.length === 0) return;

  const observer = new IntersectionObserver((entries) => {
    // 現在交差しているセクションを取得
    const intersectingEntries = entries.filter(entry => entry.isIntersecting);

    if (intersectingEntries.length === 0) return;

    // 複数交差している場合は、最も交差比が高いものを選ぶ
    const mostVisibleEntry = intersectingEntries.reduce((max, entry) =>
      entry.intersectionRatio > max.intersectionRatio ? entry : max
    );

    const linkData = sections.find(item => item.section === mostVisibleEntry.target);
    if (!linkData) return;

    // すべてのリンクから data-active を削除
    document.querySelectorAll(".js-menu-highlight a").forEach((el) => {
      el.removeAttribute("data-active");
    });
    // 現在のセクションに対応するリンクに data-active を付与
    linkData.link.setAttribute("data-active", "");
  }, options);

  sections.forEach(({ section }) => {
    observer.observe(section);
  });
};


const main = () => {
    //if (document.querySelector('#page-faq') == null) return;
    menuHighlight();
};

export default main;
